export { default, StyledIcon, StyledIconShape, registerIcon, forceRegisterIcon } from './Icon';
export type { IconProps } from './Icon';
export { default as icons } from './iconNames';
export type { IconName } from './iconNames';
export { default as streamlineIcons } from './streamlineIconNames';
export type { StreamlineIconName } from './streamlineIconNames';
